/**
 * @description: 充值结果列
 */
export const rechargeResultCols = [
  {
    title: '账号ID',
    key: 'accountId',
    width: '70'
  },
  {
    title: '账号名称',
    key: 'adAccount'
  },
  {
    title: '计划主ID',
    key: 'advertiserId'
  },
  {
    title: '媒体',
    key: 'mediaName'
  },
  {
    title: '管理人',
    key: 'opNames'
  },
  {
    title: '结算方式',
    key: 'settleTypeName'
  },
  {
    title: '实时账面余额',
    key: 'accountMoney'
  },
  {
    title: '日均消耗',
    key: 'lastThreeDaysConsume'
  },
  {
    title: '充值账面金额',
    key: 'balance'
  },
  {
    title: '返点',
    key: 'finaRebate'
  },
  {
    title: '实际金额',
    key: 'realBalance'
  }
]
/**
 * @description: 转入结果列（头条、腾讯广告）
 */
export const transferInSpecialResultCols = [
  {
    title: '转入账号',
    key: 'adAccount',
    children: [
      {
        title: '账号ID',
        key: 'accountId',
        width: '70'
      },
      {
        title: '转入账号名称',
        key: 'adAccount'
      },
      {
        title: '计划主ID',
        key: 'advertiserId'
      },
      {
        title: '媒体',
        key: 'mediaName'
      },
      {
        title: '管理人',
        key: 'opNames'
      },
      {
        title: '代理商',
        key: 'agentName'
      },
      {
        title: '实时账面余额',
        key: 'result.toAccountAmount'
      },
      {
        title: '转入账面金额',
        key: 'transferBalance'
      }
    ]
  },
  {
    title: '转出账号',
    key: 'transferAccount',
    className: 'transfer-bg-highlight',
    children: [
      {
        title: '转出账号',
        key: 'transferAccountInfo.adAccount'
      },
      {
        title: '媒体',
        key: 'transferAccountInfo.mediaName'
      },
      {
        title: '转出资金类型',
        key: 'result.transferFundTypeDesc'
      },
      {
        title: '实时总余额',
        key: 'result.fromAccountAmount'
      },
      {
        title: '现金余额',
        key: 'result.fromCashAmount'
      },
      {
        title: '授信余额',
        key: 'result.fromCreditAmount'
      }
    ]
  }
]

/**
 * @description: 转入结果列（非头条腾讯广告媒体）
 */
export const transferInNormalResultCols = [
  {
    title: '转入账号',
    key: 'adAccount',
    children: [
      {
        title: '账号ID',
        key: 'accountId',
        width: '70'
      },
      {
        title: '转入账号名称',
        key: 'adAccount'
      },
      {
        title: '计划主ID',
        key: 'advertiserId'
      },
      {
        title: '媒体',
        key: 'mediaName'
      },
      {
        title: '管理人',
        key: 'opNames'
      },
      {
        title: '代理商',
        key: 'agentName'
      },
      {
        title: '实时账面余额',
        key: 'result.toAccountAmount'
      },
      {
        title: '转入账面金额',
        key: 'transferBalance'
      }
    ]
  },
  {
    title: '转出账号',
    key: 'transferAccount',
    className: 'transfer-bg-highlight',
    children: [
      {
        title: '转出账号',
        key: 'transferAccountInfo.adAccount'
      },
      {
        title: '媒体',
        key: 'transferAccountInfo.mediaName'
      },
      {
        title: '实时总余额',
        key: 'accountMoney'
      }
    ]
  }
]

/**
 * @description: 转出结果表格列（非头条、非腾讯广告）
 */
export const transferOutNormalResultCols = [
  {
    title: '转出账号',
    key: 'adAccount',
    children: [
      {
        title: '转出账号',
        key: 'accountId'
      },
      {
        title: '媒体',
        key: 'mediaName'
      },
      {
        title: '实时总余额',
        key: 'accountMoney'
      }
    ]
  },
  {
    title: '转入账号',
    key: 'transferAccount',
    className: 'transfer-bg-highlight',
    children: [
      {
        title: '账号ID',
        key: 'transferAccountInfo.id',
        width: '70'
      },
      {
        title: '转入账号名称',
        key: 'transferAccountInfo.adAccount'
      },
      {
        title: '计划主ID',
        key: 'transferAccountInfo.advertiserId'
      },
      {
        title: '媒体',
        key: 'transferAccountInfo.mediaName'
      },
      {
        title: '管理人',
        key: 'transferAccountInfo.opNames'
      },
      {
        title: '代理商',
        key: 'transferAccountInfo.agentName'
      },
      {
        title: '实时账面余额',
        key: 'result.toAccountAmount'
      },
      {
        title: '转入账面金额',
        key: 'transferBalance'
      }
    ]
  }
]

/**
 * @description: 转出结果表格列（头条腾讯广告）
 */
export const transferOutSpecialResultCols = [
  {
    title: '转出账号',
    key: 'adAccount',

    children: [
      {
        title: '转出账号',
        key: 'adAccount'
      },
      {
        title: '媒体',
        key: 'mediaName'
      },
      {
        title: '转出资金类型',
        key: 'result.transferFundTypeDesc'
      },
      {
        title: '实时总余额',
        key: 'result.fromAccountAmount'
      },
      {
        title: '现金余额',
        key: 'result.fromCashAmount'
      },
      {
        title: '授信余额',
        key: 'result.fromCreditAmount'
      }
    ]
  },
  {
    title: '转入账号',
    key: 'transferAccount',
    className: 'transfer-bg-highlight',
    children: [
      {
        title: '账号ID',
        key: 'transferAccountInfo.id',
        width: '70'
      },
      {
        title: '转入账号名称',
        key: 'transferAccountInfo.adAccount'
      },
      {
        title: '计划主ID',
        key: 'transferAccountInfo.advertiserId'
      },
      {
        title: '媒体',
        key: 'transferAccountInfo.mediaName'
      },
      {
        title: '管理人',
        key: 'transferAccountInfo.opNames'
      },
      {
        title: '代理商',
        key: 'transferAccountInfo.agentName'
      },
      {
        title: '实时账面余额',
        key: 'result.toAccountAmount'
      },
      {
        title: '转入账面金额',
        key: 'transferBalance'
      }
    ]
  }
]
